<script>
export default {
  props: ["clr"]
};
</script>
<template>
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.0775 0.766602C15.955 0.766602 17.3734 0.964102 18.3984 1.98077C19.415 2.9891 19.595 4.3991 19.595 6.2841V14.4166C19.595 16.3024 19.415 17.7041 18.3984 18.7208C17.3817 19.7374 15.955 19.9341 14.0775 19.9341H5.88005C4.00255 19.9341 2.58422 19.7374 1.56005 18.7208C0.543382 17.7124 0.362549 16.3024 0.362549 14.4166V6.2266C0.362549 4.4066 0.551716 2.9966 1.56755 1.98827C2.58422 0.971601 4.01088 0.767435 5.82255 0.767435L14.0775 0.766602ZM9.96255 5.1616C9.49588 5.1616 9.22505 5.5141 9.22505 6.0141V9.57994H5.67505C5.15005 9.57994 4.81422 9.8666 4.81422 10.3508C4.81422 10.8174 5.17505 11.0966 5.67505 11.0966H9.22505V14.5066C9.22505 15.0066 9.49505 15.3516 9.96255 15.3516C10.4459 15.3516 10.7334 15.0233 10.7334 14.5066V11.0966H14.2992C14.7909 11.0966 15.1434 10.8174 15.1434 10.3508C15.1434 9.86743 14.8159 9.57994 14.2992 9.57994H10.7325V6.01327C10.7325 5.4966 10.4459 5.1616 9.96255 5.1616Z"
      fill="#919191"
    />
  </svg>
</template>
